import classNames from "classnames";
import { NavLink } from "react-router-dom";
import { Header as HeaderText } from "../../../atoms/Typography";

interface TabProps {
    route: string;
    title: string;
    children?: React.ReactNode;
    extraClass?: string;
}

function Tab({ route, title, children, extraClass }: TabProps) {
    return (
        <NavLink
            to={route}
            style={({ isActive }) =>
                isActive
                    ? {
                          height: "100%",
                      }
                    : undefined
            }
            id={`${title.toLowerCase()}-nav-bar-tab`}
        >
            <HeaderText size="small">
                <button className={children ? "cogWheel" : classNames("tab", extraClass)} type="button">
                    {children || title}
                </button>
            </HeaderText>
        </NavLink>
    );
}

export default Tab;
